import { emptyLabels, noItems } from './item-presets';
import type { PersonalPageCapabilities } from './types';

export const baseCompletion = { inApp: null, sms: 'Hello', email: 'Hello' };

export function cap(
  partial: Partial<Omit<PersonalPageCapabilities, 'defineStepLabelConfig'>> &
    Pick<PersonalPageCapabilities, 'dataDestination' | 'defineStepLabelConfig'>
): PersonalPageCapabilities {
  return {
    hasDefineStep: true,
    hasLocation: false,
    hasDateTime: false,
    hasStartEndRange: false,
    hasGoal: false,
    supportsGroups: false,
    hasGoalProgress: false,
    hasRecentDonations: false,
    hasAllDonations: false,
    requiresDefinedItems: false,
    itemKind: 'none',
    itemOptions: noItems,
    soldRemainingDisplay: false,
    allowDonationAtEnd: false,
    allowFreeRecurringDonation: false,
    completionMessages: baseCompletion,
    itemLabels: emptyLabels,
    label: '',
    ...partial
  };
}
